import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/FavoritedStores/GET';

export const FAVORITED_STORES_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const FAVORITED_STORES_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
